// @flow
import * as React from 'react';
import {useApi} from 'docs/data';
import Box from 'sail/Box';
import {Button} from 'sail/Button';

type EnableACHButtonProps = {|
  children: React.Node,
|};

export const EnableACHButton = ({children}: EnableACHButtonProps) => {
  const {api} = useApi();
  const [pending, setPending] = React.useState(false);
  const [enabled, setEnabled] = React.useState(false);

  const onClick = async () => {
    if (enabled) {
      return;
    }
    setPending(true);

    await api.acceptAchTos();
    setEnabled(true);
    setPending(false);
  };

  return (
    <Box padding={{vertical: 4}}>
      {enabled ? (
        <Button color="white" disabled icon="check" label="ACH Activated" />
      ) : (
        <Button
          color="blue"
          label="Enable ACH"
          onClick={onClick}
          pending={pending}
        />
      )}
    </Box>
  );
};
